<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" right="iconadd" @rightClick="onAddNew" />
    <van-collapse v-model="activeNames" accordion>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-collapse-item v-for="item in list" :key="item.complaintId">
          <template #title>
            <div>
              <van-tag plain :color="GetColorMain()">{{ GetEnumText("Em_ComplaintType",item.type ) }}</van-tag>
              &nbsp;<span style="color:#999">{{ formatDate(item.createTime,'yyyy/MM/dd') }}</span>
              &nbsp;{{ cutString(item.body,8) }}</div>
          </template>
          {{ item.body }}<br>
          <van-image
            v-for="(img,imgIndex) in item.imgList"
            :key="imgIndex"
            class="imgIndex"
            width="4em"
            height="4em"
            fit="cover"
            lazy-load
            :src="img"
            radius="0.3em"
            @click="showPreview(item.imgList)"
          />

          <div v-if="item.state!=='CREATE'">
            <van-tag plain :color="GetColorSecondary()">{{ GetEnumText("Em_ComplaintState",item.state ) }}</van-tag>
            回复:{{ item.recvBody }}
          </div>
        </van-collapse-item>
        <!-- <van-collapse-item v-for="item in list" :key="item.complaintId" :title="formatDate(item.createTime,'yyyy/MM/dd')+' '+cutString(item.body,8)" :name="item.complaintId">{{ item.body }}</van-collapse-item> -->
      </van-list>
    </van-collapse>
    <complaintAdd v-model="showNew" @reload="init" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Tag, Button, Collapse, CollapseItem, List, Image, ImagePreview } from 'vant'
import TopBar from '@/components/TopBar'
import { cutString, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import complaintAdd from '@/views/my/complaintAdd'

export default {
  components: {
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [List.name]: List,
    [Image.name]: Image,
    [ImagePreview.name]: ImagePreview,
    TopBar,
    complaintAdd
  },
  data() {
    return {
      titleTop: '',
      title: '投诉建议',
      backurl: '/my/index',
      activeNames: [],
      search: {
        limit: 30,
        page: 1
      },
      loading: undefined,
      finished: false,
      list: [],
      showNew: false
    }
  },
  activated() {
    this.init()
  },
  created() {
    this.titleTop = GetSysTitle()
  },
  methods: {
    cutString,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onAddNew() {
      this.showNew = true
    },
    showPreview(imgs) {
      ImagePreview(imgs)
    },
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      request({
        url: '/User/getUserComplaintList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          if (item.imgs) {
            item.imgList = item.imgs.split(',')
          } else {
            item.imgList = []
          }
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
        if (this.list.length <= 0) {
          this.showNew = true
        }
      })
    }
  }
}
</script>
<style scoped>

.imgIndex{
    margin:0.5em 0.5em 0 0;
    overflow: hidden;
}
</style>
